import { useEffect, useRef, useState } from "react";

// A Complete VQQ can miss its snapshot when the ingestion behind it failed. The
// snapshot endpoint then asks for the questionnaire to be ingested again and
// answers 404 with preparing=true, so the Responses tab keeps asking for a while
// instead of showing an error the reader cannot act on.
export const SNAPSHOT_PREPARING_RETRY_MS = 10000;
export const SNAPSHOT_PREPARING_MAX_RETRIES = 12;

export const isSnapshotPreparing = (error) =>
  error?.response?.status === 404 && error?.response?.data?.preparing === true;

export const useSnapshotPreparingRetry = ({
  isError,
  error,
  refetch,
  retryMs = SNAPSHOT_PREPARING_RETRY_MS,
  maxRetries = SNAPSHOT_PREPARING_MAX_RETRIES,
}) => {
  const [attempts, setAttempts] = useState(0);
  const refetchRef = useRef(refetch);
  refetchRef.current = refetch;

  const preparingError = Boolean(isError) && isSnapshotPreparing(error);
  const exhausted = attempts >= maxRetries;

  useEffect(() => {
    if (!preparingError || exhausted) return undefined;
    const timer = setTimeout(() => {
      setAttempts((count) => count + 1);
      refetchRef.current?.();
    }, retryMs);
    return () => clearTimeout(timer);
  }, [preparingError, exhausted, attempts, retryMs]);

  useEffect(() => {
    if (!isError) setAttempts(0);
  }, [isError]);

  return {
    preparing: preparingError && !exhausted,
    exhausted: preparingError && exhausted,
    attempts,
  };
};
